import ResetPasswordPage from "./reset-password-page";

export default ResetPasswordPage;
